import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "label", "maxFieldWidth"];
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';
import Flex, { Box } from 'components/Flex';
import { AlertTypes } from 'components/Alert';
import Button from 'components/Button';
import FormField from 'components/FormField';
import { StyledInput } from 'components/TextInput';
function selectAllText(_ref) {
  var target = _ref.target;
  setTimeout(function () {
    target.select();
  }, 0);
}
export default function CopyToClipboardField(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    maxFieldWidth = _ref2.maxFieldWidth,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasCopied = _useState2[0],
    setWasCopied = _useState2[1];
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: label,
    alert: wasCopied ? t('alert_copied_to_clipboard') : undefined,
    alertType: wasCopied ? AlertTypes.SUCCESS : undefined
  }, otherProps), /*#__PURE__*/React.createElement(Flex, {
    maxWidth: maxFieldWidth
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true
  }, /*#__PURE__*/React.createElement(StyledInput, {
    readOnly: true,
    type: "text",
    value: value,
    onFocus: selectAllText
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: value,
    onCopy: function onCopy() {
      return setWasCopied(true);
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "transparent",
    icon: "asset",
    ml: "xxs"
  }, t('actions_copy'))))));
}